






















































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { ExternalService } from '@/types/user'

@Component({
  components: {
    LoginModal: () => import('@/components/external/LoginModal.vue')
  }
})
export default class Manage extends Vue {
  $store!: ExStore
  selectedService: ExternalService | null = null

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  get externalServices() {
    return this.loginUser.externalServices
  }

  handleOpenExternalService(index: number) {
    this.selectedService = this.externalServices[index]
  }
}
